<template>
  <!-- 保单列表组件 -->
  <div class="insurancelist">
    <!-- 保单列表  搜索有数据 -->
    <div class="hasData" v-if="isShow">
      <el-table
        empty-text=" "
        v-loading="loading"
        :data="list"
        stripe
        :row-class-name="TableRow"
        :header-cell-style="thClass"
        :cell-style="{ color: '#666666' }"
      >
        <el-table-column
          label="保单号"
          width="224px
        "
        >
          <template slot-scope="scope">
            <span>{{ scope.row.insuranceCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="投保地块" width="234px">
          <template slot-scope="scope">
            <div class="totalLands">
              <span> {{ scope.row.landNum }}个地块</span>
              <span class="textColor">
                &nbsp;&nbsp;({{
                  scope.row.landArea ? scope.row.landArea : "--"
                }}亩)</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="投保品种" width="133px">
          <template slot-scope="scope">
            {{ scope.row.itemName ? scope.row.itemName : "--" }}
          </template>
        </el-table-column>
        <el-table-column label="每亩投保产量" width="133px">
          <template slot-scope="scope">
            {{ scope.row.quantity ? scope.row.quantity + "斤 " : "--" }}
          </template>
        </el-table-column>
        <el-table-column label="保费" width="112px">
          <template slot-scope="scope">
            {{ scope.row.premium ? scope.row.premium + "元 " : "--" }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <span class="statusColor" :class="policyColor[scope.row.status]"
              >{{ policyState[scope.row.status] }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态更新时间" width="133px">
          <template slot-scope="scope">
            {{ scope.row.updateTime | formatDate("yyyy-MM-dd") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="184px ">
          <template slot-scope="scope">
            <el-button
              @click="checkContent(scope.row)"
              type="text"
              size="small"
              class="button14"
              >查看</el-button
            >
            <el-button
              @click="downloadEle(scope.row)"
              type="text"
              size="small"
              class="button14"
              >{{
                scope.row.status == 3
                  ? "下载缴费通知书"
                  : scope.row.status == 4
                  ? "下载电子保单"
                  : ""
              }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 搜索后无数据 -->
    <div class="noDataImg" v-else>
      <div class="imgNo">
        <img src="~@/assets/images/insuranceImg/nodataImg.png" alt="" />
      </div>
      <p style="color: #333">未找到符合条件的数据</p>
    </div>
  </div>
</template>

<script>
// import { setStorage } from "@/utils/storage";
import sameIn from "@/mixins/ruralListsdetails.js";
export default {
  name: "TableList",
  mixins: [sameIn],
  data() {
    return {
      maxHeignt: 500,
      policyState: ["", "", "待缴费", "", "生效中"],
      policyColor: ["", "", "", "", "greenC"],
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  created() {},

  computed: {},

  methods: {
    checkContent(row) {
      this.$router.push({
        name: "ruralDetailsIndex",
        query: {
          type: 1,
          id: row.id,
        },
      });
    },
    // 下载
    downloadEle(row) {
      if (row.status === 3) {
        //下载付款书
        window.open(row.planNoticeUrl);
      } else if (row.status === 4) {
        // 下载电子保单
        window.open(row.elecPolicyUrl);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hasData {
  height: 100%;
}
.totalLands {
  line-height: 70px;
  display: flex;
  flex-direction: row;
  .textColor {
    color: #ccc;
  }
}
.statusColor {
  color: #ff831e;
}
.colorHui {
  color: #666666;
}
.greenC {
  color: #11d8a0;
}
</style>
